<div class="table-pagination">
    <div class="items-data" *ngIf="totalNumberOfElements > 0">
        <div class="">
            {{ startIndex }} - {{ endIndex }}
            of
            {{ totalNumberOfElements }}
        </div>
    </div>
    <div class="items-data" *ngIf="totalNumberOfElements === 0">
        <div class="">0 - 0 of 0</div>
    </div>
    <div class="navigation">
        <img src="assets/images/arrows/pagination-arrow.svg" *ngIf="pageNumber > 1" (click)="prevPageClicked()" class="left-arrow" />
        <div class="total-amount">{{ pageNumber }} of {{ totalPages }}</div>
        <img src="assets/images/arrows/pagination-arrow.svg" *ngIf="pageNumber < totalPages" (click)="nextPageClicked()" class="right-arrow" />
    </div>
</div>
